<template>
  <div class="flex-1 flex flex-v">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component
          :is="Component"
          v-if="$route.meta.keepAlive"
          :key="$route.name"
        />
      </keep-alive>
      <component
        :is="Component"
        v-if="!$route.meta.keepAlive"
        :key="$route.name"
      />
    </router-view>
  </div>
  <copy-right />
</template>
<script>
  import { title } from '@/config'
  import config from '../package.json'
  import CopyRight from '@/components/Copyright'
  export default {
    components: {
      CopyRight,
    },
    data() {
      return {
        version: config.version,
      }
    },
    created() {
      //if (process.env.NODE_ENV !== 'development') {
      // eslint-disable-next-line no-console
      console.log(
        ` %c  ${title} v${config.version}  %c by 腾宇一号 `,
        'color: #fadfa3; background: #030307; padding:5px 0;',
        'background: #fadfa3; padding:5px 0;'
      )
      //}
    },
  }
</script>
<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    background: #fff;
  }
  div,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding: 0;
    margin: 0;
  }
  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #333;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }
  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
  @media screen and (min-width: 901px) {
    .van-popup--bottom.van-popup--round {
      width: 550px !important;
      left: calc(50% - 275px) !important;
    }
  }

  // .van-tab__panel {
  //   margin-top: 20px !important;
  // }
</style>
